<!-- Property of OSF GLOBAL SERVICES INC. , an OSF Digital company. OSF remains the sole owner of all right, title and interest in the software. Do not copy, sell, reverse engineer or otherwise attempt to derive or obtain information about the functioning, manufacture or operation therein. -->
<style>
.ti-quiz-welcome {
    position: relative;
    height: calc(100vh - 10.5rem);
    overflow: hidden;
    cursor: pointer;
}
.ti-quiz-welcome-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
}
.ti-quiz-welcome-content {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    text-align: center;
    width: 100%;
    padding: 0 4rem;
}
.ti-quiz-welcome-content h1 {
    font-weight: 400;
}
</style>

<template>
    <!-- Welcome Message Container, -->
    <div class="ti-quiz-welcome ti-font-regular" v-on:click="dismissWelcome">
        <picture>
            <source
                v-if="welcomeHtml.assetImageLarge"
                :srcset="`${encodeURI(welcomeHtml.assetImageLarge)}, 2x`"
                :media="`(min-width: ${welcomeHtml.assetImageMedium ? '1200px' : '768px'})`"
            />
            <source
                v-if="welcomeHtml.assetImageMedium"
                :srcset="`${encodeURI(welcomeHtml.assetImageMedium)}, 2x`"
                media="(min-width: 768px)"
            />
            <img
                :src="encodeURI(welcomeHtml.assetImageSmall || welcomeHtml.assetImageMedium || welcomeHtml.assetImageLarge)"
                class="ti-quiz-welcome-img"
                :alt="welcomeHtml.assetBody"
            />
        </picture>
        <div class="ti-quiz-welcome-content">
            <h1 class="ti-fs-md-56" :class="[welcomeHtml.assetTextColor === 'black' ? 'ti-text-color-black' : 'ti-text-color-white']" v-html="welcomeHtml.assetBody"></h1>
            <button class="ti-btn mt-16 w-auto px-50" :class="[welcomeHtml.assetTextColor === 'black' ? 'ti-btn-third bg-transparent' : 'ti-btn-ghost']" v-on:click="dismissWelcome" v-bind:data-cbt="getDataCbtValue()">
                {{ welcomeHtml.assetButtonText }}
            </button>
        </div>
    </div>
</template>

<script>
export default {
    name: "Welcome",
    computed: {
        welcomeHtml: function () {
            return this.$store.state.welcomeHTML;
        },
        quizData: function () {
            return this.$store.state.quizData;
        },
    },
    methods: {
        dismissWelcome: function () {
            this.$store.commit("setWelcome", false);
        },
        getDataCbtValue: function () {
            let data = {
                "event" : "GiftFinderNavigation",
                "eventTypes": "click",
                "W-cat": "Gift Finder",
                "W-act": "Get Started"
            }

            return JSON.stringify(data);
        }
    },
};
</script>
